import { render, staticRenderFns } from "./recaptcha.vue?vue&type=template&id=726a1dd0&"
import script from "./recaptcha.vue?vue&type=script&lang=js&"
export * from "./recaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('726a1dd0')) {
      api.createRecord('726a1dd0', component.options)
    } else {
      api.reload('726a1dd0', component.options)
    }
    module.hot.accept("./recaptcha.vue?vue&type=template&id=726a1dd0&", function () {
      api.rerender('726a1dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-templates/recaptcha.vue"
export default component.exports